import React from "react";
import MegaMenuPanel from "./MegaMenuPanel";
import { getServicesMenuItems } from "../../config/navigation";

const sidebarImage = `${process.env.PUBLIC_URL}/i-banner.png`;
const wtssUrl = "https://wtss.co.in/";

const MegaMenuServices: React.FC = () => {
  return (
    <MegaMenuPanel
      items={getServicesMenuItems()}
      columns={3}
      sidebarTitle="Looking for industry-focused IT courses tailored to you?"
      sidebarLink={wtssUrl}
      sidebarLinkLabel="Explore Courses"
      sidebarLinkExternal
      sidebarImage={sidebarImage}
    />
  );
};

export default MegaMenuServices;
